import client from "@/api/swr/client";

async function download(url: string) {
  try {
    const response = await client.get(url, {
      responseType: "blob",
    });
    const blob = new Blob([response.data], {
      type: response.headers["content-type"],
    });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download =
      response.headers["content-disposition"]?.split("filename=")[1] ||
      "downloaded-file";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    Promise.reject(error);
  }
}

export default download;
